import { AnyAction, Dispatch, ThunkDispatch } from '@reduxjs/toolkit';

export type Initializer = {
  name: string;
  order: number;
  execute: InitializerExecutor;
  dependencies?: any[];
};

export type InitializerExecutor = (
  dispatch: ThunkDispatch<
    {
      [key: string]: any;
    },
    undefined,
    AnyAction
  > &
    Dispatch<AnyAction>
) => Promise<void>;

export const addInitializer = (
  name: string,
  order: number,
  execute: InitializerExecutor,
  dependencies?: any[]
) => {
  return { name, order, execute, dependencies };
};
